import { Link, useNavigate } from "react-router-dom"

import "../../styles/NavBar.css"

function NavBar() {
  const navigate = useNavigate()

  return (
    <div className="navbar-container" >
      <div className="navbar-panel-1">
        <div className="navbar-link-container" onClick={(() => navigate("/dining"))} >
          <Link className="navbar-link" to="/dining">Dining</Link>
        </div>
        <div className="navbar-link-container-x" onClick={(() => navigate("/catering"))} >
          <Link className="navbar-link" to="/catering">Catering / Banquet</Link>
        </div>
      </div>

      <div className="navbar-panel-2">
        <button className="navbar-button" onClick={(e) => {
          e.preventDefault();
          localStorage.removeItem("token")
          window.location.href="/order/dining"
          }}
        >Order Now</button>
      </div>

      <div className="navbar-panel-3">
        <div className="navbar-link-container" onClick={(() => navigate("/home"))} >
          <Link className="navbar-link" to="/home">Home</Link>
        </div>
        <div className="navbar-link-container" onClick={(() => navigate("/about"))} >
          <Link className="navbar-link" to="/about">About Us</Link>
        </div>
        <div className="navbar-link-container" onClick={(() => navigate("/contact"))} >
          <Link className="navbar-link" to="/contact">Contact</Link>
        </div>
      </div>      
    </div>
  )
}

export default NavBar
